<template>
  <div v-show="showSection" class="faq-section">
    <div class="section-actions">
      <el-tooltip
        content="Click to move this section before the previous one"
        placement="top"
      >
        <i
          v-if="canEdit"
          v-show="index > 0"
          class="section-up ion ion-ios-arrow-up"
          @click="moveSectionUp($event, index)"
        ></i>
      </el-tooltip>
      <el-tooltip
        content="Click to move this section after the next one"
        placement="top"
      >
        <i
          v-if="canEdit"
          v-show="index < faq.length - 1"
          class="section-down ion ion-ios-arrow-down"
          @click="moveSectionDown($event, index)"
        ></i>
      </el-tooltip>
      <el-tooltip content="Click to remove this section" placement="top">
        <i
          v-if="canEdit"
          class="remove-section ion ion-ios-close-empty"
          @click="removeSection(index)"
        ></i>
      </el-tooltip>
    </div>
    <h2 v-if="!canEditTitle" class="title">
      {{ section.section }}
    </h2>
    <input
      v-if="canEditTitle"
      class="section-header title overview-input"
      :value="section.section"
      placeholder="Section Name"
      @blur="update('section', $event, index)"
    />
    <FAQSectionElement
      v-for="(element, id) in section.items"
      v-show="editable || element.answer"
      :key="id"
      class="nostyle"
      :element-id="id"
      :section="section"
      :section-id="index"
      :element="element"
      :editable="editable"
    />

    <el-popover
      title="Tip"
      content="If you feel like there are more questions relevant to your project specifics, you can add custom questions here and answer them right away."
      placement="right"
      trigger="hover"
      width="600"
    >
      <button
        v-if="editable"
        slot="reference"
        class="btn btn-sm btn-primary"
        @click="addQuestion(index)"
      >
        Add question
      </button>
    </el-popover>
  </div>
</template>

<script>
import FAQSectionElement from './FAQSectionElement.vue'
import { DEFAULT_FAQ_SECTIONS } from 'services/startup'
import { mapState } from 'vuex'
import { isSectionFilled } from './helpers'

export default {
  components: { FAQSectionElement },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    section: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: null,
    },
  },
  computed: {
    canEdit() {
      return false
    },
    canEditTitle() {
      return (
        this.editable &&
        !this.nonEditableSectionTitles.has(this.section.section)
      )
    },
    canAddNewQuestion() {
      return this.section.section !== 'General'
    },
    hasAtLeastOneAnswer() {
      return isSectionFilled(this.section)
    },
    showSection() {
      return this.editable || this.hasAtLeastOneAnswer
    },
    ...mapState({
      user: (s) => s.user.data,
    }),
  },
  data() {
    return {
      nonEditableSectionTitles: new Set(),
    }
  },
  created() {
    this.nonEditableSectionTitles = new Set()
    DEFAULT_FAQ_SECTIONS.forEach((s) =>
      this.nonEditableSectionTitles.add(s.section),
    )
  },
  methods: {
    addQuestion(index) {
      this.$store.commit('startupProfile/ADD_FAQ_ELEMENT', { index })
    },

    moveSectionUp($event, index) {
      this.$store.commit('startupProfile/FAQ_SECTION_MOVED_BACK', { index })
    },

    moveSectionDown($event, index) {
      this.$store.commit('startupProfile/FAQ_SECTION_MOVED_FORWARD', { index })
    },

    update(property, event, index) {
      const value = event.target.value
      this.$store.commit(
        `startupProfile/UPDATE_FAQ_${property.toUpperCase()}`,
        { value, index },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.faq-section {
  margin-bottom: 40px;

  input.section-header {
    font-size: 24px;
  }
}
</style>
